const workerUrl = '/push-service-worker.js';
const storageKey = (player: string) => `arkhamPushSubscription:${encodeURIComponent(player.toLowerCase())}`;

export function pushUnavailableReason(): string | null {
  if (!window.isSecureContext) return 'Push notifications require HTTPS or localhost.';
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return ios
      ? 'To receive push notifications, add this app to your Home Screen and open it from there.'
      : 'Push notifications are not supported in this browser.';
  }
  return null;
}

export async function getPushRegistration(): Promise<ServiceWorkerRegistration> {
  const registration = await navigator.serviceWorker.register(workerUrl, { scope: '/', updateViaCache: 'none' });
  if (registration.active) return registration;
  await new Promise<void>((resolve, reject) => {
    const worker = registration.installing || registration.waiting;
    if (!worker) { reject(new Error('Push service worker could not start.')); return; }
    const timer = window.setTimeout(() => { worker.removeEventListener('statechange', changed); reject(new Error('Push service worker did not start. Please retry.')); }, 15000);
    const changed = () => {
      if (worker.state === 'activated' || worker.state === 'redundant') {
        window.clearTimeout(timer);
        worker.removeEventListener('statechange', changed);
        if (worker.state === 'activated') resolve();
        else reject(new Error('Push service worker could not start.'));
      }
    };
    worker.addEventListener('statechange', changed);
    changed();
  });
  return registration;
}

export function applicationServerKey(value: string): Uint8Array {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')), c => c.charCodeAt(0));
}

export function readPushSubscriptionId(player: string): string | null {
  try { return localStorage.getItem(storageKey(player)); } catch { return null; }
}

export function savePushSubscriptionId(player: string, id: string | null): void {
  if (id) localStorage.setItem(storageKey(player), id);
  else localStorage.removeItem(storageKey(player));
}
